import { createViewConfig } from '@sail/engine';
export const SearchFieldConfig = createViewConfig({
    name: 'SearchField',
    props: {},
    defaults: {
        defaultExpandedKeys: 'all',
        expandable: false,
        selectionMode: 'single'
    }
});

//# sourceMappingURL=SearchFieldConfig.js.map